import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("inventory") !== null && localStorage.getItem("inventory") !== undefined && localStorage.getItem("inventory") !== "") {

    data = JSON.parse(localStorage.getItem("inventory"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getinventory: (state, action) => {
            localStorage.setItem("inventory", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { seedetails, home, getinventory } = Insider.actions;
export default Insider.reducer;